
import { Component, Mixins } from 'vue-property-decorator';
import LayoutPublic from '@/layouts/LayoutPublic.vue';
import ContentBlocks from '@/components/content/ContentBlocks.vue';
import CmsContentMixin from '@/mixins/CmsContentMixin';
import GoogleTagManagerLogic from '@/logic/google-tag-manager/GoogleTagManagerLogic';

@Component({
  components: { LayoutPublic, ContentBlocks },
})
export default class MenuEngineeringWelcomeResult extends Mixins(
  CmsContentMixin,
) {
  get category(): string {
    return this.$route.params.category;
  }

  mounted() {
    GoogleTagManagerLogic.pushEvent(
      'menu-engineering-completed',
      this.$route.fullPath,
    );
    this.fetchContent();
    this.$watch(
      '$i18n.locale',
      (newLocale, oldLocale) => {
        if (newLocale === oldLocale) {
          return;
        }
        this.fetchContent();
      },
      { immediate: true },
    );
  }
}
